// Shared decrypt helpers that were duplicated (behavior-identical) across
// UserManagement / UserGroupDetail / UserChatManagement / SetupUserGroup.
// Pure functions — no component state.
import CryptoJS from "crypto-js";

export function decryptData(encryptedText, key) {
  const decryptedBytes = CryptoJS.AES.decrypt(encryptedText, key);
  const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
  return decryptedText;
}

export function decryptShiftData(encryptedText, shift) {
  let chars = encryptedText.split("");
  let decryptedChars = [];

  for (let c of chars) {
    if (/[a-zA-Z]/.test(c)) {
      let offset =
        c === c.toUpperCase() ? "A".codePointAt(0) : "a".codePointAt(0);
      c = String.fromCodePoint(
        ((c.codePointAt(0) - offset - shift + 26) % 26) + offset
      );
    } else if (/\d/.test(c)) {
      c = String.fromCodePoint(
        ((c.codePointAt(0) - "0".codePointAt(0) - shift + 10) % 10) +
          "0".codePointAt(0)
      );
    }

    decryptedChars.push(c);
  }

  return decryptedChars.join("");
}
